import {Component, inject} from '@angular/core';
import {RealEstateLeasingBaseInfoForm} from "./forms/real-estate-leasing-base-info.form";
import {stages} from "../../real-estate-leasing.routes";
import {ApplicationAppEntityApplicationRead} from "../../../../../../openapi";
import {ApplicationCommonComponent} from "../../../common/application.common.component";
import {StagesComponent} from "../../../../../../common/stages/stages.component";
import {ReactiveFormsModule} from "@angular/forms";
import {SpinnerComponent} from "../../../../../../common/spinner/spinner.component";
import {CommonModule} from "@angular/common";
import {ValidationErrorsComponent} from "../../../../../../common/validation-errors/validation-errors.component";
import {DatePickerComponent} from "../../../../../../common/date-picker/date-picker.component";
import {NgxMaskDirective} from "ngx-mask";

@Component({
  selector: 'app-real-estate-leasing-base-info-section',
  standalone: true,
  imports: [
    StagesComponent,
    ReactiveFormsModule,
    SpinnerComponent,
    CommonModule,
    ValidationErrorsComponent,
    DatePickerComponent,
    NgxMaskDirective
  ],
  providers: [RealEstateLeasingBaseInfoForm],
  templateUrl: './real-estate-leasing-base-info-section.component.html'
})
export class RealEstateLeasingBaseInfoSectionComponent extends ApplicationCommonComponent {

  public stages: string[] = stages;

  public form: RealEstateLeasingBaseInfoForm = inject(RealEstateLeasingBaseInfoForm);

  public override onFetchApplicationData = (app: ApplicationAppEntityApplicationRead | null) => {
    if (app) {
      this.form.patchFormValues({
        ...app
      });
    }
  };

  public submitAndGoNext(): void {
    if (this.form.valid) {
      if (this.applicationId) {
        this.updateApplication('dane-identyfikacyjne', this.form.toWriteModel());
      } else {
        this.createApplication('dane-identyfikacyjne', this.form.toWriteModel());
      }
    } else {
      this.form.markAllAsTouched();
    }
  }

}
